module.exports = __webpack_public_path__ + "static/media/cts-furniture-img.92b08b0b.png";